// @ts-ignore
// @ts-nocheck
import { AxiosPromise } from 'axios';
import api from './api';

export type DeleteUnitProps = {
  customerCode: string;
  document: string;
  siteId: string;
  userId?: string;
  code?: string;
};

export const deleteAddressService = async ({
  userId,
  customerCode,
  document,
  siteId,
}: DeleteUnitProps): Promise<AxiosPromise> => {
  const url = `industrial/customer/v1/users/${userId}/customers`;
  const header = {
    'Content-Type': 'application/json',
    access_token: localStorage.getItem('@UltragazEmpresarial:accessToken'),
  };

  const response = await api.delete(url, {
    headers: header,
    data: {
      customerCode,
      document,
      siteId,
    },
  });

  return response;
};
